import axiosIns from '@/libs/axios'

const ROOT_URL = '/targets'

export default {
  namespaced: true,
  state: {
    dataList: [],
    metaData: {
      total: 0, page: 1, limit: 50, totalPages: 0,
    },
    detail: null,
    dataSave: { message: null, status: null },
  },
  getters: {
    dataList: s => s.dataList,
    metaData: s => s.metaData,
    detail: s => s.detail,
    dataSaveStatus: s => s.dataSave,
  },
  mutations: {
    SET_DATA_LIST(state, data) { state.dataList = data },
    SET_META_DATA(state, data) { state.metaData = data },
    SET_DETAIL(state, data) { state.detail = data },
    SET_DATA_SAVE(state, data) { state.dataSave = data },
  },
  actions: {
    getDataList({ commit }, params) {
      return axiosIns.post(ROOT_URL, params || {})
        .then(response => {
          commit('SET_DATA_LIST', response.data.data)
          commit('SET_META_DATA', response.data.meta || {
            total: 0, page: 1, limit: 50, totalPages: 0,
          })
        })
        .catch(error => {
          console.error(error)
          commit('SET_DATA_SAVE', { status: false, message: 'Hedef listesi alınamadı.' })
        })
    },
    getDetail({ commit }, id) {
      return axiosIns.get(`${ROOT_URL}/${id}`)
        .then(response => commit('SET_DETAIL', response.data.data))
        .catch(error => { console.error(error); commit('SET_DETAIL', null) })
    },
    create({ commit, dispatch }, body) {
      return axiosIns.post(`${ROOT_URL}/create`, body)
        .then(response => {
          commit('SET_DATA_SAVE', { status: true, message: 'Hedef oluşturuldu.' })
          dispatch('getDataList', {})
          return response.data.data
        })
        .catch(error => {
          console.error(error)
          const msg = error?.response?.data?.message || 'Oluşturma başarısız.'
          commit('SET_DATA_SAVE', { status: false, message: msg })
          throw error
        })
    },
    update({ commit, dispatch }, { id, body }) {
      return axiosIns.patch(`${ROOT_URL}/${id}`, body)
        .then(response => {
          commit('SET_DATA_SAVE', { status: true, message: 'Hedef güncellendi.' })
          dispatch('getDataList', {})
          return response.data.data
        })
        .catch(error => {
          console.error(error)
          const msg = error?.response?.data?.message || 'Güncelleme başarısız.'
          commit('SET_DATA_SAVE', { status: false, message: msg })
          throw error
        })
    },
    rollbackStrategyDoctor({ commit, dispatch }, id) {
      return axiosIns.post(`${ROOT_URL}/${id}/strategy-doctor/rollback`)
        .then(response => {
          commit('SET_DATA_SAVE', { status: true, message: 'Strategy Doctor rollback uygulandı.' })
          dispatch('getDataList', {})
          dispatch('getDetail', id)
          return response.data.data
        })
        .catch(error => {
          console.error(error)
          const msg = error?.response?.data?.message || 'Rollback başarısız.'
          commit('SET_DATA_SAVE', { status: false, message: msg })
          throw error
        })
    },
    remove({ commit, dispatch }, id) {
      return axiosIns.delete(`${ROOT_URL}/${id}`)
        .then(() => {
          commit('SET_DATA_SAVE', { status: true, message: 'Hedef silindi.' })
          dispatch('getDataList', {})
        })
        .catch(error => {
          console.error(error)
          const msg = error?.response?.data?.message || 'Silme başarısız.'
          commit('SET_DATA_SAVE', { status: false, message: msg })
        })
    },
    start({ commit, dispatch }, id) {
      return axiosIns.post(`${ROOT_URL}/${id}/start`)
        .then(() => {
          commit('SET_DATA_SAVE', { status: true, message: 'Hedef aktifleştirildi.' })
          dispatch('getDataList', {})
        })
        .catch(error => {
          console.error(error)
          const msg = error?.response?.data?.message || 'Başlatma başarısız.'
          commit('SET_DATA_SAVE', { status: false, message: msg })
        })
    },
    stop({ commit, dispatch }, id) {
      return axiosIns.post(`${ROOT_URL}/${id}/stop`)
        .then(() => {
          commit('SET_DATA_SAVE', { status: true, message: 'Hedef durduruldu.' })
          dispatch('getDataList', {})
        })
        .catch(error => {
          console.error(error)
          commit('SET_DATA_SAVE', { status: false, message: 'Durdurma başarısız.' })
        })
    },
    recompute({ commit, dispatch }, id) {
      return axiosIns.post(`${ROOT_URL}/${id}/recompute`)
        .then(response => {
          commit('SET_DETAIL', response.data.data)
          dispatch('getDataList', {})
          return response.data.data
        })
        .catch(error => {
          console.error(error)
          const msg = error?.response?.data?.message || 'Yenileme başarısız.'
          commit('SET_DATA_SAVE', { status: false, message: msg })
        })
    },
    provisionBots({ commit, dispatch }, { id, body }) {
      return axiosIns.post(`${ROOT_URL}/${id}/provision-bots`, body)
        .then(response => {
          const data = response.data.data || {}
          commit('SET_DATA_SAVE', {
            status: true,
            message: `${data.botCount || 0} bot oluşturuldu${data.skipped && data.skipped.length ? ` (${data.skipped.length} atlandı)` : ''}.`,
          })
          dispatch('getDataList', {})
          dispatch('getDetail', id)
          return data
        })
        .catch(error => {
          console.error(error)
          const msg = error?.response?.data?.message || 'Provision başarısız.'
          commit('SET_DATA_SAVE', { status: false, message: msg })
          throw error
        })
    },
    reconcileBots({ commit, dispatch }, id) {
      return axiosIns.post(`${ROOT_URL}/${id}/reconcile-bots`)
        .then(response => {
          commit('SET_DATA_SAVE', { status: true, message: 'Hedef botları eşitlendi.' })
          dispatch('getDataList', {})
          dispatch('getDetail', id)
          return response.data.data
        })
        .catch(error => {
          console.error(error)
          const msg = error?.response?.data?.message || 'Bot eşitleme başarısız.'
          commit('SET_DATA_SAVE', { status: false, message: msg })
          throw error
        })
    },
    getAvailableEdges(_ctx, { market = 'FUTURES', kind = 'NORMAL' } = {}) {
      return axiosIns.get(`${ROOT_URL}/available-edges`, { params: { market, kind } })
        .then(response => response.data.data)
        .catch(error => { console.error(error); return { count: 0 } })
    },
    backtest({ commit }, { id, body }) {
      return axiosIns.post(`${ROOT_URL}/${id}/backtest`, body || {})
        .then(response => {
          commit('SET_DATA_SAVE', { status: true, message: 'Hedef backtest başlatıldı.' })
          return response.data.data
        })
        .catch(error => {
          console.error(error)
          const msg = error?.response?.data?.message || 'Backtest başarısız.'
          commit('SET_DATA_SAVE', { status: false, message: msg })
          throw error
        })
    },
    getBacktestJob(_ctx, { id, jobId }) {
      return axiosIns.get(`${ROOT_URL}/${id}/backtest/${jobId}`)
        .then(response => response.data.data)
        .catch(error => {
          console.error(error)
          throw error
        })
    },
    cancelBacktestJob({ commit }, { id, jobId }) {
      return axiosIns.post(`${ROOT_URL}/${id}/backtest/${jobId}/cancel`)
        .then(response => {
          commit('SET_DATA_SAVE', { status: true, message: 'Hedef backtest iptal edildi.' })
          return response.data.data
        })
        .catch(error => {
          console.error(error)
          const msg = error?.response?.data?.message || 'Backtest iptal edilemedi.'
          commit('SET_DATA_SAVE', { status: false, message: msg })
          throw error
        })
    },
    getLatestBacktestJob(_ctx, id) {
      return axiosIns.get(`${ROOT_URL}/${id}/backtest`)
        .then(response => response.data.data)
        .catch(error => {
          console.error(error)
          return null
        })
    },
  },
}
